import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IProductLoaderState } from '../../interfaces/product-loader.interface';

@Injectable()

/**
 * Inicialización de la clase ProductLoaderService, modelo para la configuración de los estados de carga de la aplicación
 *
 * *Set ProductLoaderService class, loading config states model*
 *
 * @access public
 * @type {class}
 */
export class ProductLoaderService {

  /**
   * Instancia de loaderSubject como Subject<IProductLoaderState>
   *
   * *Sets loaderSubject instance as SubjectIProductLoaderState>*
   *
   * @access private
   *
   * @type {Subject<IProductLoaderState>()} loaderSubject
   */
  private loaderSubject = new Subject<IProductLoaderState>();

  /**
   * Inicialización de loaderState as Observable
   *
   * *Sets loader state as observable*
   *
   *  @param {Observable} loaderState
   */
  loaderState = this.loaderSubject.asObservable();

  /**
   * Activa el estado de carga y muestra el mensaje de los parámetros
   *
   * *Turns up loading state and shows the message from the parameters*
   *
   *  @param {string} msg
   */
  show(msg?: string, timer?: number) {
    this.loaderSubject.next({ show: true, msg, timer } as IProductLoaderState);
  }

  showPercentage(msg?: string) {
    this.loaderSubject.next({ show: true, msg, activePer: true } as IProductLoaderState);
  }

  /**
   * Desactiva el estado de carga
   *
   * *Turns off loading state*
   */
  hide() {
    this.loaderSubject.next({ show: false } as IProductLoaderState);
  }

}
